import {
  SHIPPERORDERS_FETCH,
  HANDLING_NOT_ALLOWED,
  SHIPPERORDER_CREATE,
  SHIPPERORDER_UPDATE,
  SHIPPERORDER_PRICE,
  JOURNEY_LAUNCH,
  JOURNEY_UNASSIGN,
  JOURNEY_COST,
  JOURNEY_ADVANCE,
} from './constants';

const messages = {
  500: {
    default: {
      title: "An error has occurred in TMS's server.",
      description: 'Please check that the lastest changes have been saved correctly, or try again.',
    },
    [SHIPPERORDER_UPDATE]: {
      title: "An error has occurred in TMS's server updating the order.",
      description: 'Please check that the lastest changes have been saved correctly, or try again.',
    },
    [SHIPPERORDER_PRICE]: {
      title: "An error has occurred in TMS's server calculating the price for the order.",
      description: 'Please check if it has been calculated or try again.',
    },
    [SHIPPERORDERS_FETCH]: {
      title: "An error has occurred in TMS's server trying to load shipperorders.",
      description: 'Please check if they have loaded correctly, or try again reloading.',
    },
    [JOURNEY_LAUNCH]: {
      title: "An error has occurred in TMS's server launching the journey.",
      description: 'Please check that it has been launched correctly, or try again.',
    },
    [JOURNEY_COST]: {
      title: "An error has occurred in TMS's server calculating the cost for the job.",
      description: 'Please check if it has been calculated or try again.',
    },
    [JOURNEY_ADVANCE]: {
      title: "An error has occurred in TMS's server trying to advance the status of the job.",
      description: 'Please check if it has been advanced correctly, or try again.',
    },
    [JOURNEY_UNASSIGN]: {
      title: "An error has occurred in TMS's server trying to unassign the job.",
      description: 'Please check if it has been unassigned correctly, or try again.',
    },
  },
  400: {
    default: {
      title: 'Bad request',
      description: 'The server could handle the request',
    },
    [SHIPPERORDER_CREATE]: {
      title: 'Bad request creating shipper order',
      description: 'The server could handle the request',
    },
    [SHIPPERORDER_UPDATE]: {
      title: 'Bad request updating shipper order',
      description: 'The server could handle the request',
    },
    [HANDLING_NOT_ALLOWED]: {
      title: 'Handling not allowed',
      description: 'Handling is not allowed for this load',
    },
  },
};

export default messages;
